import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  integrationDatoId: string
}

export const IntegrationSetupButton = ({ integrationDatoId }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Button.Router
      to={navigation.discover.marketplace.item.fullPath({ id: integrationDatoId })}
      rel="nofollow noopener noreferrer"
      type="secondary"
      iconName="settings"
      blankTarget
    >
      {i18n.t('ats.job_details.promotion.job_boards.buttons.set_up_button')}
    </Button.Router>
  )
}
